import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.pos.sales.receipt');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-pos-sales-receipt',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.pos.sales.receipt/view.scss */
:host {
  display: block;
  height: 100%;
  overflow: hidden;
}

* {
  box-sizing: border-box;
}

.receipt-page {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: var(--pos-bg);
  color: var(--pos-text);
  font-family: "Noto Sans KR", -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: 13px;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: var(--pos-panel);
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
}
.page-header .back-btn {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.page-header .back-btn:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}
.page-header .page-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.page-body {
  flex: 1;
  display: flex;
  min-height: 0;
  overflow: hidden;
}

.left-panel {
  flex: 1;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--pos-border);
  overflow: hidden;
  min-width: 0;
}

.order-table-section {
  flex: 1;
  overflow: auto;
  min-height: 120px;
}

.order-table th, .order-table td {
  font-size: 12px;
}

.receipt-mgmt-btn-area {
  padding: 6px 10px;
  flex-shrink: 0;
}
.receipt-mgmt-btn-area .receipt-mgmt-btn {
  width: 100%;
  padding: 8px;
  border-radius: 6px;
  border: 1px solid var(--pos-accent);
  background: var(--pos-selected);
  color: var(--pos-accent);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.receipt-mgmt-btn-area .receipt-mgmt-btn:hover {
  background: var(--pos-hover);
}

.order-actions {
  padding: 6px 10px;
  display: flex;
  gap: 4px;
  flex-shrink: 0;
  flex-wrap: nowrap;
}
.order-actions .act-btn {
  flex: 1;
  padding: 7px 2px;
  border-radius: 4px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 11px;
  cursor: pointer;
  text-align: center;
  white-space: nowrap;
  min-width: 0;
}
.order-actions .act-btn:hover {
  background: var(--pos-hover);
}
.order-actions .act-btn:active {
  transform: scale(0.97);
}

.bottom-area {
  display: flex;
  flex-shrink: 0;
  border-top: 1px solid var(--pos-border);
  min-height: 0;
}

.payment-section {
  flex: 1;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
}
.payment-section .pay-info-row {
  display: flex;
  gap: 8px;
  margin-bottom: 4px;
}
.payment-section .pay-info-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 6px 8px;
  background: var(--pos-card);
  border: 1px solid var(--pos-border);
  border-radius: 4px;
}
.payment-section .pay-info-item .pay-label {
  font-size: 10px;
  color: var(--pos-text-dim);
}
.payment-section .pay-info-item .pay-value {
  font-size: 12px;
  font-weight: 600;
}
.payment-section .pay-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;
}
.payment-section .pay-row.highlight {
  background: var(--pos-hover);
  border-radius: 4px;
  padding: 4px 6px;
  margin: 1px -6px;
}
.payment-section .pay-label {
  font-size: 12px;
  color: var(--pos-text-dim);
}
.payment-section .pay-value {
  font-size: 13px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
}
.payment-section .pay-value.accent {
  color: var(--pos-accent);
  font-size: 15px;
}
.payment-section .pay-value.green {
  color: var(--pos-green);
  font-size: 15px;
}
.payment-section .pay-divider {
  height: 1px;
  background: var(--pos-border);
  margin: 3px 0;
}

.keypad-section {
  width: 180px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  border-left: 1px solid var(--pos-border);
  border-right: 1px solid var(--pos-border);
}
.keypad-section .keypad-display {
  background: var(--pos-input-bg, var(--pos-bg));
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  padding: 6px 10px;
  margin-bottom: 6px;
  text-align: right;
  font-size: 18px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  min-height: 36px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.keypad-section .keypad-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;
  flex: 1;
  align-content: start;
}
.keypad-section .kp-btn {
  padding: 10px 4px;
  border-radius: 4px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
}
.keypad-section .kp-btn:hover {
  background: var(--pos-hover);
}
.keypad-section .kp-btn:active {
  transform: scale(0.95);
}
.keypad-section .kp-clear {
  color: var(--pos-red);
}
.keypad-section .kp-enter {
  grid-column: span 2;
  background: var(--pos-accent);
  color: #fff;
  font-weight: 600;
}
.keypad-section .kp-enter:hover {
  background: var(--pos-accent-hover, #2563eb);
}

.side-buttons {
  width: 70px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 8px 6px;
  flex-shrink: 0;
}
.side-buttons .side-btn {
  flex: 1;
  padding: 6px 2px;
  border-radius: 4px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 11px;
  cursor: pointer;
  text-align: center;
  word-break: keep-all;
}
.side-buttons .side-btn:hover {
  background: var(--pos-hover);
}

.right-panel {
  width: 46%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
}

.search-section {
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  background: var(--pos-panel);
  border-bottom: 1px solid var(--pos-border);
  flex-shrink: 0;
  align-items: flex-end;
}
.search-section .search-grid {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.search-section .search-row {
  display: flex;
  gap: 10px;
}
.search-section .field-item {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 6px;
}
.search-section .field-item label {
  width: 68px;
  font-size: 12px;
  color: var(--pos-text-dim);
  flex-shrink: 0;
  text-align: right;
}
.search-section .field-item input {
  flex: 1;
  height: 28px;
  padding: 0 8px;
  background: var(--pos-input-bg, var(--pos-bg));
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  color: var(--pos-text);
  font-size: 12px;
  outline: none;
}
.search-section .field-item input:focus {
  border-color: var(--pos-accent);
}
.search-section .search-actions {
  display: flex;
  flex-direction: column;
  gap: 5px;
  justify-content: flex-end;
}

.action-btn {
  padding: 6px 14px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
}
.action-btn.outline {
  background: transparent;
  border: 1px solid var(--pos-border);
  color: var(--pos-text-dim);
}
.action-btn.outline:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}
.action-btn.primary {
  background: var(--pos-accent);
  color: #fff;
}
.action-btn.primary:hover {
  background: var(--pos-accent-hover, #2563eb);
}

.receipt-list-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  flex-shrink: 0;
  border-bottom: 1px solid var(--pos-border);
  background: var(--pos-panel);
}

.receipt-list-title {
  font-size: 13px;
  font-weight: 600;
}

.plus-btn {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-accent);
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.plus-btn:hover {
  background: var(--pos-hover);
}

.receipt-list-section {
  flex: 1;
  overflow: auto;
  min-height: 0;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.receipt-card {
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  cursor: pointer;
  transition: all 150ms;
}
.receipt-card:hover {
  border-color: var(--pos-accent);
  background: var(--pos-hover);
}
.receipt-card.selected {
  border-color: var(--pos-accent);
  background: var(--pos-selected);
  box-shadow: 0 0 0 1px var(--pos-accent);
}

.rc-top {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.rc-no {
  font-size: 11px;
  font-weight: 700;
  color: var(--pos-text-dim);
}

.rc-receipt {
  font-size: 12px;
  font-weight: 600;
  color: var(--pos-text);
}

.rc-status {
  margin-left: auto;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 500;
  background: rgba(52, 199, 89, 0.15);
  color: var(--pos-green);
}
.rc-status.refund {
  background: rgba(255, 59, 48, 0.15);
  color: var(--pos-red);
}

.rc-bottom {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.rc-detail {
  display: flex;
  align-items: center;
  gap: 4px;
}

.rc-label {
  font-size: 10px;
  color: var(--pos-text-dim);
}

.rc-val {
  font-size: 12px;
  font-weight: 500;
  color: var(--pos-text);
}

.rc-amount {
  color: var(--pos-accent);
  font-weight: 700;
}

.receipt-detail-section {
  flex-shrink: 0;
  border-top: 1px solid var(--pos-border);
  padding: 10px 12px;
  background: var(--pos-panel);
}
.receipt-detail-section .detail-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 13px;
  font-weight: 600;
}
.receipt-detail-section .detail-content {
  min-height: 120px;
  background: var(--pos-input-bg, var(--pos-bg));
  border: 1px solid var(--pos-border);
  border-radius: 4px;
  margin-bottom: 10px;
}
.receipt-detail-section .detail-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  align-items: center;
}

.detail-btn {
  padding: 5px 10px;
  border-radius: 4px;
  border: 1px solid var(--pos-border);
  background: var(--pos-card);
  color: var(--pos-text);
  font-size: 11px;
  cursor: pointer;
}
.detail-btn:hover {
  background: var(--pos-hover);
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 11px;
  color: var(--pos-text-dim);
  cursor: pointer;
}
.checkbox-label input {
  accent-color: var(--pos-accent);
}

.pos-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.pos-table thead {
  position: sticky;
  top: 0;
  z-index: 1;
}
.pos-table thead th {
  padding: 7px 6px;
  background: var(--pos-table-header, var(--pos-bg));
  border-bottom: 1px solid var(--pos-border);
  color: var(--pos-text-dim);
  font-weight: 600;
  text-align: center;
  white-space: nowrap;
}
.pos-table tbody tr {
  cursor: pointer;
  transition: background 100ms;
}
.pos-table tbody tr:hover {
  background: var(--pos-hover);
}
.pos-table tbody tr.selected {
  background: var(--pos-selected);
}
.pos-table tbody tr td {
  padding: 6px;
  border-bottom: 1px solid var(--pos-border);
  border-bottom-color: rgba(128, 128, 128, 0.08);
  text-align: center;
  white-space: nowrap;
}
.pos-table .text-right {
  text-align: right;
}
.pos-table .text-center {
  text-align: center;
}

.modal-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-box {
  width: 900px;
  max-height: 80vh;
  background: var(--pos-panel);
  border: 1px solid var(--pos-border);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.2);
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid var(--pos-border);
}
.modal-header h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}

.close-btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid var(--pos-border);
  background: transparent;
  color: var(--pos-text-dim);
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.close-btn:hover {
  background: var(--pos-card);
  color: var(--pos-text);
}

.modal-body {
  flex: 1;
  padding: 14px 16px;
  overflow: auto;
}

.modal-table-wrap {
  overflow: auto;
  max-height: 50vh;
}

.modal-receipt-table th, .modal-receipt-table td {
  font-size: 11px;
  padding: 6px 5px;
}

.modal-footer {
  padding: 10px 16px;
  border-top: 1px solid var(--pos-border);
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}`],
})
export class PagePosSalesReceiptComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {}

    // ─── 검색 조건 ───
    public searchDate: string = '';
    public searchPosNo: string = '';
    public searchReceiptNo: string = '';
    public searchTable: string = '';
    public searchMobile: string = '';
    public searchOrderNo: string = '';

    // ─── 영수증 목록 ───
    public receipts: any[] = [];
    public selectedReceipt: any = null;

    // ─── 주문 상품 목록 ───
    public orderItems: any[] = [];
    public selectedOrderIdx: number = -1;

    // ─── 결제 정보 ───
    public paymentInfo: string = '';
    public paymentDetail: string = '';
    public memberInfo: string = '';
    public totalAmount: number = 0;
    public discountAmount: number = 0;
    public dueAmount: number = 0;
    public receivedAmount: number = 0;
    public changeAmount: number = 0;

    // ─── 키패드 ───
    public keypadValue: string = '';

    // ─── 영수증 내역 버튼 ───
    public receiptActionButtons: string[] = ['재출력', '반품', '현금영수증', '반품재매출', '회원적립'];
    public hideProductDetail: boolean = false;

    // ─── 우측 기능 버튼 ───
    public sideButtons: string[] = ['환전', '포장', '전체포장', '회원등록', '확장메뉴'];

    // ─── 영수증 목록 모달 ───
    public showReceiptListModal: boolean = false;
    public receiptListModalData: any[] = [];

    public async ngOnInit() {
        await this.service.init();
        await this.loadReceipts();
        await this.service.render();
    }

    public async loadReceipts() {
        let res = await wiz.call("load_receipts", {
            searchDate: this.searchDate,
            searchReceiptNo: this.searchReceiptNo,
            searchTable: this.searchTable,
        });
        if (res.code === 200) {
            this.receipts = res.data.receipts || [];
            this.receiptListModalData = res.data.receiptListModalData || [];
        }
    }

    public goBack() {
        this.service.href('/pos/sales');
    }

    // ─── 검색/조회 ───
    public async onSearch() {
        await this.loadReceipts();
        await this.service.render();
    }

    public async onPrintSlip() {
        if (!this.selectedReceipt) return;
        const res = await wiz.call("receipt_print", { orderId: this.selectedReceipt.receiptNo });
        if (res.code === 200 && res.data.html) {
            this.printHtml(res.data.html);
        }
        await this.service.render();
    }

    // ─── 영수증 선택 ───
    public async selectReceipt(receipt: any) {
        this.selectedReceipt = receipt;
        let res = await wiz.call("receipt_detail", { orderId: receipt.receiptNo });
        if (res.code === 200) {
            this.orderItems = res.data.orderItems || [];
            this.totalAmount = res.data.totalAmount || 0;
            this.discountAmount = res.data.discountAmount || 0;
            this.dueAmount = res.data.dueAmount || 0;
            this.receivedAmount = res.data.receivedAmount || 0;
            this.changeAmount = res.data.changeAmount || 0;
            this.paymentInfo = res.data.method || '';
        } else {
            this.orderItems = [];
            this.totalAmount = receipt.amount;
            this.discountAmount = 0;
            this.dueAmount = receipt.amount;
            this.receivedAmount = receipt.amount;
            this.changeAmount = 0;
        }
        this.selectedOrderIdx = -1;
        await this.service.render();
    }

    public async selectOrderItem(idx: number) {
        this.selectedOrderIdx = idx;
        await this.service.render();
    }

    // ─── 주문 조작 ───
    public async cancelAll() {
        if (!this.selectedReceipt) return;
        await wiz.call("refund_receipt", { orderId: this.selectedReceipt.receiptNo });
        await this.loadReceipts();
        await this.service.render();
    }
    public async cancelSelected() { await this.cancelAll(); }
    public async applyDiscount() { await this.service.render(); }
    public async changeQty() { await this.service.render(); }

    public async decreaseQty() {
        if (this.selectedOrderIdx >= 0 && this.orderItems[this.selectedOrderIdx]) {
            const item = this.orderItems[this.selectedOrderIdx];
            if (item.qty > 1) {
                item.qty--;
                item.amount = item.price * item.qty - item.discount;
            }
        }
        await this.service.render();
    }

    public async increaseQty() {
        if (this.selectedOrderIdx >= 0 && this.orderItems[this.selectedOrderIdx]) {
            const item = this.orderItems[this.selectedOrderIdx];
            item.qty++;
            item.amount = item.price * item.qty - item.discount;
        }
        await this.service.render();
    }

    public async moveUp() {
        if (this.selectedOrderIdx > 0) {
            const temp = this.orderItems[this.selectedOrderIdx];
            this.orderItems[this.selectedOrderIdx] = this.orderItems[this.selectedOrderIdx - 1];
            this.orderItems[this.selectedOrderIdx - 1] = temp;
            this.selectedOrderIdx--;
        }
        await this.service.render();
    }

    public async moveDown() {
        if (this.selectedOrderIdx >= 0 && this.selectedOrderIdx < this.orderItems.length - 1) {
            const temp = this.orderItems[this.selectedOrderIdx];
            this.orderItems[this.selectedOrderIdx] = this.orderItems[this.selectedOrderIdx + 1];
            this.orderItems[this.selectedOrderIdx + 1] = temp;
            this.selectedOrderIdx++;
        }
        await this.service.render();
    }

    // ─── 영수증 목록 모달 ───
    public async openReceiptListModal() {
        this.showReceiptListModal = true;
        await this.service.render();
    }

    public async closeReceiptListModal() {
        this.showReceiptListModal = false;
        await this.service.render();
    }

    public async printAllSlips() {
        for (const receipt of this.receipts) {
            const res = await wiz.call("receipt_print", { orderId: receipt.receiptNo });
            if (res.code === 200 && res.data.html) this.printHtml(res.data.html);
        }
        await this.service.render();
    }

    public async selectFromModal() {
        this.showReceiptListModal = false;
        await this.service.render();
    }

    // ─── 키패드 ───
    public onKey(key: string) {
        if (key === 'C') {
            this.keypadValue = '';
        } else if (key === 'DEL') {
            this.keypadValue = this.keypadValue.slice(0, -1);
        } else if (key === 'ENTER') {
            // ENTER action
        } else {
            this.keypadValue += key;
        }
        this.service.render();
    }

    public formatCurrency(val: number): string {
        return (val || 0).toLocaleString();
    }

    private printHtml(html: string) {
        const win = window.open('', '_blank', 'width=420,height=640');
        if (!win) return;
        win.document.open();
        win.document.write(html);
        win.document.close();
    }
}

export default PagePosSalesReceiptComponent;